import { Component, OnInit, Input } from '@angular/core';

import * as _ from 'lodash';
import { UserService } from '../../../../services/core.user.service';
import { BreadcrumbService } from '../../../../../widgets/breadcrumbs/breadcrumbs.service';
import { MyReportsRest } from '../services/myreports.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { marker } from '../../../../services/ngx-translate-extract-marker';

@Component({
  selector: 'my-reports-list',
  template: require('./myreports.list.component.html')
})
export class MyReportsListComponent implements OnInit {
  @Input() myReports: any;

  user: any;
  crumbs: any[];
  deleteItem: any;

  constructor(
    public stateService: StateService,
    private userService: UserService,
    private breadcrumbService: BreadcrumbService,
    private myReportsRest: MyReportsRest,
    private uiService: UiService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.user = this.userService.session.getUser();
    this.crumbs = [
      this.breadcrumbService.userMyPageCrumb(this.user),
      this.breadcrumbService.translatedCrumb(marker('My Reports'), 'home.user.myreports', { unixName: this.user.unixName })
    ];
  }

  refresh() {
    this.myReports = false;
    this.deleteItem = false;
    const params = this.stateService.params;
    this.myReportsRest.fetch(params)
      .then(response => {
        this.myReports = _.get(response, 'items', []);
      })
      .catch(err => {
        console.log(err);
        this.uiService.message.showSuccess("", "Could not fetch my reports");
        this.myReports = [];
      });
  }

  checkDelete(item: any) {
    if (this.isDelete(item)) {
      this.myReportsRest.delete(this.deleteItem.id)
        .then(response => {
          this.uiService.message.showSuccess(
            this.translateService.translate("Report {{reportName}} was deleted", item),
            this.translateService.translate("Delete Report")
          );
        })
        .catch(response => {
          console.log(response);
          this.uiService.message.showWarning(
            this.translateService.translate("Report {{reportName}} was not deleted", item),
            this.translateService.translate("Delete Report")
          );
        })
        .finally(() => this.refresh());
    } else {
      this.deleteItem = item;
    }
  }

  canDelete(item: any) {
    return _.get(item, 'user.id', 100) === _.get(this.user, 'id', -1);
  }

  isDelete(item: any) {
    return _.get(this.deleteItem, 'id', -1) === _.get(item, 'id', -2);
  }

  clearDelete(item: any) {
    if (this.isDelete(item)) {
      this.deleteItem = false;
    }
  }

  trackByFn(index: number, item: any): any {
    return item?.id ?? item;
  }
}
